import React, { useEffect, useState } from 'react';
import { useTargetMarketsList } from '../../../../../hooks/useTargetMarketsList';
import styles from '../../businessAssetsPage.module.css';
import { Icon, SortableList, Text } from '@bloobirds-it/flamingo-ui';
import { SearchLogs } from '../../../../../../assets/svg';
import { headerNames } from './targetMarketsList.constants';
import { TargetMarketCard } from './targetMarketCard/targetMarketCard';
import {
  EntityHeaderItem,
  EntityList,
  EntityListHeader,
} from '../../../../../components/entityList/entityList';
import { EntityCard } from '../../../../../components/entityList/entityCard/entityCard';
import { useOrdering } from '../../../../../hooks/useOrdering';
import { mutate } from 'swr';

export const TargetMarketsList = ({ searchValue, setShowExamplePage }) => {
  const { targetMarkets } = useTargetMarketsList();
  const { parseOrderingRequest, handleUpdateOrdering } = useOrdering();
  const [targetMarketsList, setTargetMarketsList] = useState(targetMarkets);
  useEffect(() => {
    if (searchValue) {
      const filteredList = targetMarkets.filter(targetMarket =>
        targetMarket.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
      setTargetMarketsList(filteredList);
    } else {
      setTargetMarketsList(targetMarkets);
    }
  }, [searchValue, targetMarkets]);

  return (
    <>
      {targetMarkets?.length > 0 ? (
        <EntityList>
          {targetMarketsList?.length > 0 ? (
            <>
              <EntityListHeader>
                <EntityHeaderItem />
                {headerNames.map(name => (
                  <EntityHeaderItem label={name?.label} key={name?.label} />
                ))}
              </EntityListHeader>
              <SortableList
                className={styles._tbody}
                onReorder={v => {
                  setTargetMarketsList(v);
                  const newOrdering = parseOrderingRequest({ list: v, takeIndex: true });
                  handleUpdateOrdering({
                    list: newOrdering,
                    entityName: 'targetMarkets',
                    callback: () => {
                      mutate('/targetMarket');
                    },
                  });
                }}
                disabled={searchValue?.length > 0}
                data={targetMarketsList}
                keyExtractor={tm => tm?.id}
                renderItem={({ item: tm, innerRef, containerProps, handleProps, isDragging }) => (
                  <EntityCard
                    ref={innerRef}
                    {...containerProps}
                    {...handleProps}
                    className={isDragging && styles._card__dragging}
                  >
                    <TargetMarketCard tm={tm} />
                  </EntityCard>
                )}
              />
            </>
          ) : (
            <div className={styles._no_results__contents}>
              <SearchLogs className={styles._no_results__img} />
              <Text size="xl" weight="bold" align="center" color="softPeanut">
                No target markets for the following search
              </Text>
            </div>
          )}
        </EntityList>
      ) : (
        <div className={styles._no_results__contents}>
          <SearchLogs className={styles._no_results__img} />
          <Text size="xl" weight="bold" align="center" color="softPeanut">
            Still no target markets have been created
          </Text>
          <Text size="m" align="center" weight="regular" color="softPeanut">
            See how setting up your playbook correctly can help you in your sales process! See some
            examples to inspire you, then click the Create Target Market button to get started.
          </Text>
          <span onClick={() => setShowExamplePage(true)}>
            <Icon name="eye" color="purple" size={16} />
            <Text htmlTag="span" size="xs" color="purple" className={styles._link}>
              See some examples
            </Text>
          </span>
        </div>
      )}
    </>
  );
};
